import React from 'react';
import PropTypes from "prop-types";

require('./Textarea.scss');

const Textarea = ({theme = 'default', value, label, maxWidth = 'unset', maxHeight = 'unset', viewMode = false, handleParentChange, deleted = false, className = "", ...rest}) => {
    const disabled = rest.disabled;

    const handleChange = (e) => {
        const key = e.currentTarget.name;
        const value = e.currentTarget.value;
        handleParentChange(key, value);
        return value;
    };

	return (
        <div className={`textarea-container ${theme} ${className}`}>
            {
                label &&
                <label className={`textarea-label ${theme}${disabled ? ' disabled': ''}`}>{label}</label>
            }
            {
                !viewMode &&
				<textarea className={`textarea ${theme}${disabled ? ' disabled' : ''}`}
                          style={{maxWidth: maxWidth, maxHeight: maxHeight}}
						  value={value || ''}
						  onChange={handleChange}
						  {...rest}
				/>
            }
            {
                viewMode && <div className={deleted ? "textarea-view-mode-deleted" : ""}>{value || "-"}</div>
            }
        </div>
    )
};

Textarea.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    label: PropTypes.string,
    maxWidth: PropTypes.string,
    maxHeight: PropTypes.string,
    disabled: PropTypes.bool,
    viewMode: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    deleted: PropTypes.bool,
    className: PropTypes.string,
};

export default Textarea;